import { useState } from 'react';

/** Copies `text` to the clipboard and says so for a moment. */
export default function CopyButton({ text, label = 'Copy' }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); setDone(true); setTimeout(() => setDone(false), 1500); } catch { /* clipboard blocked */ }
  };
  return (
    <button type="button" className="btn btn-small btn-secondary" onClick={copy} aria-live="polite">
      {done ? 'Copied' : label}
    </button>
  );
}
